import {EmptyConfig} from "./types";
import {ReactElement} from "react";
import {PageFragment, PageFragmentProps} from "./PageFragment";
import {StyledEmpty} from "./StyledComponents";

export type NotFoundFragmentProps = PageFragmentProps & {
  config?: EmptyConfig,
}

export class NotFoundFragment extends PageFragment<NotFoundFragmentProps> {

  render(): ReactElement {
    return this.props.config ? <StyledEmpty emptyConfig={this.props.config}/> : this.renderNotFound();
  }
}
